import {combineReducers,configureStore} from "@reduxjs/toolkit";
import appSlice from "./slices/appSlice";
import authSlice from "./slices/auth/authSlice";
import ordersSlice from "./slices/orders/ordersSlice";
import supportsSlice from "./slices/supports/supportsSlice";
import financeSlice from "./slices/finance/financeSlice";
import usersSlice from "./slices/users/usersSlice";


const rootReducer = combineReducers({
    app: appSlice,
    auth: authSlice,
    orders: ordersSlice,
    supports: supportsSlice,
    finance: financeSlice,
    users: usersSlice
});

export const store = configureStore({
    reducer: rootReducer
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch